// @flow
import * as React from 'react';
import styled from 'styled-components';
import Image from 'components/Image';
import {LayoutCenterMiddle, LayoutRightBottom} from 'components/Layout';
import {LocalizedButton, Paragraph, useLocalized} from 'components/Localized';
import {ButtonNextPageBlack} from 'components/ButtonNextPage';
import * as VideoUtils from 'utils/videoUtils';

import Logo from 'components/Logo'

type Props = {
  onNext: () => void,
  isHidden: boolean,
}

const testPopup = false;

export default function MaxSpeed(props: Props): React.Element<any> {
  const localized = useLocalized();
  
  const onNext = React.useRef(props.onNext);
  const nodeRef = React.useRef(null);
  const [videoPlaying, setVideoPlaying] = React.useState(true);
  const [showSkipButton, setShowSkipButton] = React.useState(false);
  const [skipPopup, setSkipPopup] = React.useState(false);
  const timer1 = React.useRef(null);
  const timer2 = React.useRef(null);

  React.useEffect(()=>{

    function updateVisibility() {
      if (nodeRef.current !== null) {
        if (videoPlaying !== VideoUtils.isPlaying()) {
          setVideoPlaying(VideoUtils.isPlaying());
        }
      }
      if (timer1.current == null) {
        if (VideoUtils.isPlaying()) {
          timer1.current = setTimeout(() => setShowSkipButton(true), 3000);
        }
      }
    }

    let checkVideoStateTimer = window.setInterval(updateVisibility, 1000);
    try {
    }
    catch(e) {
      console.log(e);
    }
    
    return ()=>{
      if (checkVideoStateTimer != null) {
        window.clearInterval(checkVideoStateTimer);
        checkVideoStateTimer = null;
      }
    };
  }, [videoPlaying]);

  React.useEffect(()=>{
    VideoUtils.loadA04_1();
    VideoUtils.onEnd(()=>{
      if (onNext.current !== null) {
        onNext.current(); 
      }
    });
    
    try {
      VideoUtils.play();
    }
    catch(e) {
      console.log(e);
    }

    return ()=>{
      VideoUtils.unload();
      clearTimeout(timer1.current);
      clearTimeout(timer2.current);
    };
    
  }, []);
  

  return (
    <main>
      <DivPlayButton videoPlaying={videoPlaying}>
        <button ref={nodeRef} onClick={() => {
          console.log('play');
          VideoUtils.play();
          timer2.current = setTimeout(() => setShowSkipButton(true), 3000);
          setVideoPlaying(true);
        }
      }><Image source="./home/btn-play.png" /></button>
      </DivPlayButton>
      
      {showSkipButton && <ButtonNextPageBlack title={localized.tutorial_p00_intro_001} onNext={() => {
        window.tagManager.step3MaxSpeedSkipLinkClick();
        setSkipPopup(true);
      } }  />}
      <LayoutRightBottom>
        {(skipPopup || testPopup) &&
        <DivSkipPopup>
          <Paragraph textKey="driving_a07_maxspeed_popup_001" />
          <div>
            <LocalizedButton {...localized.driving_a07_maxspeed_popup_002} onClick={() => setSkipPopup(false)} />
            <LocalizedButton {...localized.driving_a07_maxspeed_popup_003} onClick={props.onNext} />
          </div>
        </DivSkipPopup>}
      </LayoutRightBottom>
      <Logo />
      
    </main>
  );
}

const DivPlayButton = styled(LayoutCenterMiddle)`
  button {
    width: ${props => props.theme.layout.mobile ? 68 : 80}px;
    height: ${props => props.theme.layout.mobile ? 68 : 80}px;
    visibility: ${props => props.videoPlaying ? "hidden":""};
  }
`;
const DivSkipPopup = styled.div`
  width: ${props => props.theme.layout.mobile ? 164 : 300}px;
  min-height: ${props => props.theme.layout.mobile ? 72 : 113}px;
  padding: ${props => props.theme.layout.mobile ? 15 : 30}px;
  background-color: #ffffff;

  position: absolute;
  right: ${props => props.theme.layout.mobile ? 30 : 80}px;
  bottom: ${props => props.theme.layout.mobile ? 77 : 119}px;

  > p {
    text-align: center;
    padding-bottom: ${props => props.theme.layout.mobile ? 15 : 24}px;
  }

  > div {
    padding: 0px ${props => props.theme.layout.mobile ? 7 : 12}px;
    display: flex;
    justify-content: space-between;
    > button {
      width: ${props => props.theme.layout.mobile ? 70 : 130}px;
      height: ${props => props.theme.layout.mobile ? 30 : 48}px;
      background-color: #05141f;
    }
  }
`;